import { Question } from '@jupiterone/jupiter-types/question';
import React from 'react';
import QuestionModal from '../QuestionModal';
import useVariantQuestionModalHook, {
  HookProps,
} from './useVariantQuestionModalLogic';

interface Props extends HookProps {
  question?: Question;
  logicHook?: any;
}

const defaultQuestion: Question = {
  id: '',
  name: '',
  description: '',
  lastUpdatedTimestamp: 0,
  title: '',
  queries: [],
  compliance: [],
};

const VariantQuestionModal = ({
  variant,
  open,
  onClose,
  question = defaultQuestion,
  onSubmit,
  refetchQuestions,
}: Props) => {
  const { complianceStandards, variantProps } = useVariantQuestionModalHook({
    variant,
    open,
    onClose,
    onSubmit,
    refetchQuestions,
  });

  if (!open) {
    return null;
  }

  return (
    <QuestionModal
      open={open}
      question={question}
      onClose={onClose}
      complianceStandards={complianceStandards}
      {...variantProps()}
    />
  );
};
export default VariantQuestionModal;
